
import { gql } from '@apollo/client';

/*
    dish
      ├─nutrition
      └─[tags]
*/

export const NutritionItem = gql`
  fragment nutritionItemFragment on nutritionItem {
    title
    value
    unit
  }
`;

export const Nutrition = gql`
    fragment nutritionFragment on nutrition {
        carbohydrate {
            ...nutritionItemFragment
        }
        fat {
            ...nutritionItemFragment
        }
        protein {
            ...nutritionItemFragment
        }
        calories {
            ...nutritionItemFragment
        }
    }
    ${NutritionItem}
`;

export const MenuDish = gql`
    fragment menuDishFragment on menuDish {
        id
        title
        titleEn
        caption
        captionEn
        cooking_time
        cook_until
        composition
        weight
        price
        promoPrice
        portions
        previewImage
        previewMobileImage
        verticalImage
        umAlias
        categoryId: category_id
        category_description
        subcategory_id
        subcategory_name
        partnersComment
           # BR-1104
        secondDishPart
        secondDishPartNM
        secondDishPartID
        replaceableIngredient
        upsell_dishes {
            id
            title
            name_upsell
            price
            portions
        }
        nutrition {
            ...nutritionFragment
        }
        wideImage
        metaLabel @client
        ny_name
        ny_description
        ny_mass
        ny_time
        ny_detail
        ny_content
        ny_full_price
        ny_cook_time
        ny_total_volume
    }
    ${Nutrition}
`;

